<template>
  <table class="c-data-table" v-if="versions  && versions.length > 0">
    <tr
      v-for="(version, index) in versions"
      :key="index"
    >
      <td width="35%" @click="onClickTableRow(version)">{{ version.title }}</td>
      <td width="10%" class="u-ta-center" @click="onClickTableRow(version)">{{ version.version }}</td>
      <td width="15%" class="u-ta-center" v-if="rowData.policy_number" @click="onClickTableRow(version)">
        {{ rowData.policy_number }}
      </td>
      <td width="15%" @click="onClickTableRow(version)">{{ rowData.primary_category.name }}</td>
      <td width="15%" class="u-ta-center" @click="onClickTableRow(version)">
        <base-datetime :date="version.created_time"></base-datetime>
      </td>
      <document-actions
        class="u-ta-center u-padding-0"
        :rowData="version"
        width="10%"
      ></document-actions>
    </tr>
  </table>

  <table v-else>
    <tr>
      <td v-if="!loading" width="100%">
        <span>No additional versions found</span>
      </td>
      <td v-else width="100%">
        <loading></loading>
      </td>
    </tr>
  </table>
</template>

<script>
import DocumentActions from '@/components/DocumentActions.vue'

export default {
  name: 'document-detail-row',

  components: {
    DocumentActions
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    },
    options: {
      type: Object
    }
  },

  created() {
    this.$store.dispatch('documents/listVersions', this.rowData.id)
  },

  computed: {
    versions() {
      return this.$store.getters['documents/versions'](this.rowData)
    },

    loading() {
      return this.$store.state.documents.loadingDocVersions
    }
  },

  methods: {
    onClickTableRow(version) {
      this.$router.push({
        name: 'AdminDocumentVersionPreview',
        params: {
          id: this.rowData.id,
          versionId: version.id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
tr.vuetable-detail-row {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
  background: $colour-nhs-white;

  tr:last-of-type {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
  }

  > td {
    padding: 0;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  tr.vuetable-detail-row tr {
    background: tint($colour-nhs-pale-grey, 40);
  }
}
</style>
